import { observer } from 'mobx-react-lite'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import useStore from 'reusable/mobx-store-utils'
import useInitialMount from 'reusable/hooks/useInitialMount'
import SkeletonLoader from 'reusable/mui/skeleton/SkeletonLoader'
import { useOrgGuardStore } from 'features/main/main-router/org-guard/OrgGuardStore'
import { useOrgSubscriptionTierStore } from 'features/main/main-router/org-guard/main-container/org-subscription-tiers/OrgSubscriptionTierStore'
import { themeConfig } from '@gap/shared/theme'
import { BillingStore, BillingStoreProvider } from './BillingStore'
import { PlanGrid } from './PlanGrid'

export const PlanSelection = observer(function PlanSelection() {
   const orgGuardStore = useOrgGuardStore()
   const orgSubscriptionTierStore = useOrgSubscriptionTierStore()
   // PlanSelection only renders inside the upgrade modal, so a successful plan change should close it.
   const billingStore = useStore(sp => new BillingStore(sp), { orgGuardStore, orgSubscriptionTierStore, onPlanChanged: () => orgSubscriptionTierStore.upgradePlanModal.close() })
   useInitialMount(billingStore.fetch)
   const plansForActiveTab = billingStore.planTabIndex === 0 ? billingStore.individualPlans : billingStore.multiUserPlans

   return <BillingStoreProvider store={billingStore}>
      <SkeletonLoader loading={billingStore.loader.isLoading} width="100%" height={320}>
         <Tabs
            value={billingStore.planTabIndex}
            onChange={billingStore.changePlanTab}
            sx={{
               minHeight: '40px',
               borderBottom: `1px solid ${themeConfig.primary[200]}`,
               mb: 3,
               '.MuiTab-root': { textTransform: 'none', minHeight: '40px' },
            }}
         >
            <Tab value={0} label="Individual plans" />
            <Tab value={1} label="Multi-user plans" />
         </Tabs>
         <PlanGrid plans={plansForActiveTab} />
      </SkeletonLoader>
   </BillingStoreProvider>
})
